import { render, staticRenderFns } from "./QrCodeWidget.vue?vue&type=template&id=c8565fbc&scoped=true"
import script from "./QrCodeWidget.vue?vue&type=script&lang=js"
export * from "./QrCodeWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8565fbc",
  null
  
)

export default component.exports